import script from "./WebCode.vue?vue&type=script&setup=true&lang=js"
export * from "./WebCode.vue?vue&type=script&setup=true&lang=js"

import "./WebCode.vue?vue&type=style&index=0&id=34528dae&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34528dae"]])

export default __exports__